export const actionCopyIt = {
    next: "Avanti",
    back: "Indietro",
    save: "Salva",
    send: "Invia",
    skip: "Salta",
    skipForNow: "Non lo so ancora",
    continue: "Continua",
    cancel: "Annulla",
    delete: "Elimina",
    submit: "Invia",
    confirm: "Conferma",
    add: "Aggiungi",
    edit: "Modifica",
    done: "Completato",
    stop: "Interrompi",
    retry: "Riprova",
    download: "Scarica",
    apply: "Applica",
    filter: "Filtra",
    filters: "Filtri",
    columns: "Colonne",
    close: "Chiudi",
    search: "Cerca",
    more: "Altro",
    none: "Nessuno",
    previous: "Precedente",
    rename: "Rinomina",
    duplicate: "Duplica",
    share: "Condividi",
    clearAll: "Cancella tutto",
    clearSearch: "Cancella la ricerca",
    loading: "Caricamento...",
    open: "Apri",
    invite: "Invita",
    saveCorrection: "Salva la correzione",
    saving: "Salvataggio...",
    sending: "Invio...",
    submitting: "Invio...",
    skipping: "Salto in corso...",
    goingBack: "Ritorno in corso...",
    goingNext: "Passaggio al successivo...",
    cancelling: "Annullamento...",
    deleting: "Eliminazione...",
    deleteConfirmTitle: "È assolutamente sicuro/a?",
    deleteConfirmDescription: "Questa azione è irreversibile.",
    continuing: "Proseguimento...",
    confirming: "Conferma in corso...",
    adding: "Aggiunta...",
    editing: "Modifica in corso...",
    finishing: "Finalizzazione...",
    stopping: "Interruzione...",
    retrying: "Nuovo tentativo...",
    downloading: "Scaricamento...",
};
